import React, {useState} from 'react'
import {NavLink, Route, Router, Switch, Redirect} from "react-router-dom";
import Layout from "~/Admin/Layout/Layout";
import TopMenu from '../Layout/TopMenu/TopMenu';
import AdminEventDetails from "./AdminEventDetails/AdminEventDetails";
import AdminEventContent from "./AdminEventContent/AdminEventContent";
import AdminEventItinerary from "./AdminEventItinerary/AdminEventItinerary";
import AdminViewItinerary from "./AdminEventItinerary/AdminViewItinerary";

const AdminEvent = ({match, ...props}) => {

    return (
        <Layout>

            <h1>Event Set Up</h1>

            <TopMenu>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}`}>
                    Event Details
                </NavLink>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}/content`}>
                    Content Management
                </NavLink>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}/itinerary`}>
                    Itinerary Documents
                </NavLink>
            </TopMenu>

            <div className="content mt-5">
                <Route exact path={`${match.path}`} component={AdminEventDetails} />
                <Route exact path={`${match.path}/content`} component={AdminEventContent} />
                <Route exact path={`${match.path}/itinerary`} component={AdminEventItinerary} />
                {/*<Route exact path={`${match.path}/itinerary/:id(\\d+)`} component={AdminViewItinerary} />*/}
            </div>

        </Layout>
    );
}

export default AdminEvent;
